import { render } from "./ModalFormNotification.vue?vue&type=template&id=9a8df324"
import script from "./ModalFormNotification.vue?vue&type=script&lang=js"
export * from "./ModalFormNotification.vue?vue&type=script&lang=js"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__